import colors from 'styleBM/colors.module.scss'

export const horizontalDottedLine = (props) => {
    const {strokeWidth = 2, dashLength = 8, spaceLength, clear = false, stroke = `${colors['grey-60']}`, className } = props ?? {}
    return <svg className={className??''} width="100%" height={strokeWidth} xmlns="http://www.w3.org/2000/svg">
    <line x1="0%" y1="50%" x2="100%" y2="50%" strokeWidth={strokeWidth} stroke={clear ? "none" : stroke} strokeDasharray={`${dashLength} ${spaceLength ?? dashLength}`}/>
</svg>
}
